import React from 'react';
import styled from '@emotion/styled';
import NavBar from '../layouts/NavBar';

import {SubTitle, RecentEvent, SelectTarget, Features, Greeting, SNS, Place, TopMenuPc,TopMenuPhone,Top } from '../components/HomeComponent';

import Footer from '../layouts/Footer';
import Emotiontheme from '../../config/theme';
import Materialtheme from '../../config/theme2';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import {ThemeProvider as MaterialThemeProvider} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

// icons
import LocalBarIcon from '@material-ui/icons/LocalBar';
import CategoryIcon from '@material-ui/icons/Category';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import SEO from '../components/ContentsComponent/SEO';
import { graphql } from 'gatsby'; 

const HeadWrap = styled.header`
    width:100%;
    max-width:100%;
    positon:relative;
    display:block;
    margin-top:40px;
    ${'' /* background-color: #FDF7F7; */}
    background-color:white;
    ${'' /* background-color: orange; */}
    text-align:center;
`;

const Main = ({data}) => {
    // themeprovider定義可
    const theme = useTheme();
    const isPhoneSize = useMediaQuery(theme.breakpoints.down('xs'));
    const isPcSize = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <EmotionThemeProvider theme={Emotiontheme}>
        <MaterialThemeProvider theme={Materialtheme}>
        <SEO />
        <HeadWrap id="top">
            <NavBar />
            <Top img={data.topImg.childImageSharp.fluid} isPc={isPcSize}/>
            {isPhoneSize ? 
            <TopMenuPhone
              PartyIcon={<LocalBarIcon fontSize="large" color="primary" />}  
              CategoryIcon={<CategoryIcon fontSize="large" color="secondary" />}
              HowtoIcon={<FindInPageIcon fontSize="large" color="primary" />}
              MannerIcon={<AccessibilityNewIcon fontSize="large" color="secondary" />}
              DetailIcon={<CheckCircleIcon fontSize="large" color="primary" />}
              /> 
            : 
            <TopMenuPc
              PartyIcon={<LocalBarIcon fontSize="large" color="secondary" />} 
              CategoryIcon={<CategoryIcon fontSize="large" color="primary" />}
              HowtoIcon={<FindInPageIcon fontSize="large" color="secondary" />}
              MannerIcon={<AccessibilityNewIcon fontSize="large" color="primary" />}
              DetailIcon={<CheckCircleIcon fontSize="large" color="secondary" />}
              />}

            <SubTitle isphone={isPhoneSize} />
            <RecentEvent isphone={isPhoneSize} />
            <SelectTarget />
            {/* <Features /> */}
            {/* {!isPhoneSize && <Greeting img={data.greetImg.childImageSharp.fluid} />} */}
            <SNS/>
            <Place index={true} />
            <Footer />
        </HeadWrap>
        </MaterialThemeProvider>
        </EmotionThemeProvider>
    )
}

export default Main;

// images
export const query = graphql`
    query{

        topImg : file(relativePath: { eq: "top1.jpg"}) {
            childImageSharp{
        fluid(
            maxWidth:1500
            quality:80
        ) {
        ...GatsbyImageSharpFluid_noBase64
        }
        }
        }
        snsImg : file(relativePath: { eq: "Snspic.png" }) {
            childImageSharp{
        fluid(
            maxWidth:1500
            quality:80
        ) {
        ...GatsbyImageSharpFluid_noBase64
        }
        }
        }
        greetImg : file(relativePath: { eq: "greeting.png" }) {
            childImageSharp{
        fluid(
            maxWidth:1500
            quality:80
        ) {
        ...GatsbyImageSharpFluid_noBase64
        }
        }
        }

    }`;


